<div class="add-device upgradeConfirm"  *ngIf="upgradable">
  <div class="login-logo">
    <img src="../assets/images/logo.png">
  </div>
  <div class="ui-dialog-content">
    <div class="alert alert-critical">
      <p-steps [(activeIndex)]="stepIndex" [readonly]="true"></p-steps>
      <div class="flex">
        <div class="pie-wrapper">
          <div class="circle-progress">
            <span class="label">{{stepIndex}}<span class="smaller">/{{progressTotal}}</span></span>
          </div>
        </div>
        <h4>Upgrade to PPC <span>PRO</span></h4>
      </div>
    </div>
    <div class="dialog-content">
      <section *ngIf="stepIndex === 1">
        <div class="form-group">
          <label>Agree</label>
          <p-checkbox [(ngModel)]="agreeUpgrade" [binary]="true" [disabled]="upgradeAccountLoading"></p-checkbox> <span> By clicking ‘Agree’ ,  you authorize us to proceed with the upgrade process.
          </span>
        </div>
        <p-accordion class="moretips">
          <p-accordion>
            <p-header>
              <span class="fa fa fa-info-circle"></span> <span translate>More detail</span>
            </p-header>
            <ol class="alert tips stepAgree">
              <li>
                <strong class="title" translate>Professional Account Management: </strong>
                <span translate>Seamlessly manage multiple organizations and accounts with expert-level tools designed for scalability and efficiency.</span>
              </li>
              <li>
                <strong class="title" translate>NPM Bank System: </strong>
                <span translate>Your PPC Pro nodes are shown as NPM <strong translate>(Nodes per Month) </strong>. The PPC Pro nodes you purchase will be placed into your NPM Bank. If your NPM Bank balance runs low or a payment falls behind for over a month, your account will be temporarily locked until payment is resolved.</span>
              </li>
              <li>
                <strong class="title" translate>Minimum Monthly Usage Requirement:</strong>
                <span translate>Your PPC Pro Account will use a minimum of 20 nodes per month. Your NPM Bank must have a balance to meet this minimal requirement to maintain access to PPC Pro services.</span>
              </li>
            </ol>
          </p-accordion>
        </p-accordion>
      </section>
      <section *ngIf="stepIndex === 2">
        <h5>Account Upgrade Complete</h5>
        <p>Please log out and log back in to begin using PPC Pro.</p>
        <ul class="alert alert-warning">
          <li>
            <span class="title">Activate date: </span>
            <span>{{DocDateParam.ActivateDate}}</span>
          </li>
          <li>
            <span class="title">Next NPM Settlement Date: </span>
            <span>{{DocDateParam.SettlementDate}}</span>
          </li>
        </ul>
      </section>
    </div>
  </div>
  <div class="add-device-footer">
    <section *ngIf="stepIndex === 1">
      <div *ngIf="!upgradeAccountLoading">
        <button type="button" pButton (click)="upgradeAccount();" label="{{'Upgrade' | translate}}" class="ui-button-danger" [disabled]="agreeUpgrade === false"></button>
        <button type="button" pButton (click)="cancel();" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
      </div>
      <button type="button" pButton label="{{'Loading' | translate}}" class="ui-button-danger default" icon="fa fa-circle-o-notch fa-spin" *ngIf="upgradeAccountLoading"></button>
    </section>
    <section *ngIf="stepIndex === 2">
      <button type="button" pButton (click)="redirectLogin();" label="{{'Confirm' | translate}}" class="ui-button-danger"></button>
    </section>
  </div>
</div>
